import { DataModel } from "common/models/utility-models/base-model";

export class AssignmentReportsModel extends DataModel {
    selectedBatch: string = '';
    selectedRegion: string = '';
    selectedState: string = '';
    selectedBranch: string = '';
    selectedGender: string = '';
    selectedStatus: string = '';
    selectedLocation: string = '';
    selectedType: string = '';
    selectedCategory: string = '';
    selectedAttended: string = '';
    selectedFromDate: string = '';
    selectedToDate: string = '';
}

